import {IFetchRoomProtection} from '../../incase-domain/rooms/room.player';
import {RoomProtectionReducerTypes} from './types/roomProtection.reducer.types';
import {
    IRoomInfoModal,
    SET_ROOM_INFO_MODAL,
    SET_ROOM_PASSWORD_ERROR,
    SET_ROOM_PROTECTION,
} from '../actions/types/roomProtection.action.types';
import {TypedTranslation} from '../../i18n';

export interface RoomProtectionState {
    protection: IFetchRoomProtection | undefined;
    modal: IRoomInfoModal;
    error: TypedTranslation | null;
}

export const roomProtectionPreloadedState: RoomProtectionState = {
    protection: undefined,
    modal: {open: false, title: '', description: ''},
    error: null,
};

export const roomProtectionReducer = (
    state: RoomProtectionState = roomProtectionPreloadedState,
    action: RoomProtectionReducerTypes
): RoomProtectionState => {
    switch (action.type) {
        case SET_ROOM_PROTECTION:
            return {...state, protection: action.protection};
        case SET_ROOM_INFO_MODAL:
            return {...state, modal: action.modal};
        case SET_ROOM_PASSWORD_ERROR:
            return {...state, error: action.error};
        default:
            return state;
    }
};
